import * as types from "../actions/actionTypes";
import { getAllReportsResponse } from "../actions";
import { createEntitySagas, extractPayloadAndCallback, errorMessage, toQuery, selectCompanyId } from "./sagaHelpers";
import { axiosGet } from "../../utils/common/axios";
import { call, takeLatest, fork } from "redux-saga/effects";

export const reportEntity = createEntitySagas({
  entity: "report",
  endpoint: "reports",
  label: "Report",
  scope: "none",
  selectSlice: (state) => state.report,
  listKey: "reports",
  types: {
    getAll: types.GET_ALL_REPORTS,
    create: types.CREATE_REPORT,
    remove: types.DELETE_REPORT,
  },
  actions: { getAllResponse: getAllReportsResponse },
});

function* exportReportSaga(action) {
  const { payload, callback } = extractPayloadAndCallback(action);
  const { id, format, ...queryParams } = payload;
  try {
    // Always inject companyId into the query string
    const companyId = yield* selectCompanyId(payload);
    const qs = toQuery({ format, companyId, ...queryParams });
    const response = yield call(axiosGet, `reports/${id}/export${qs}`, {
      responseType: format === "json" ? "json" : "blob",
    });
    if (callback?.success) callback.success(response?.data);
  } catch (error) {
    if (callback?.error) callback.error(errorMessage(error, "Failed to export report"));
  }
}

export function* reportSaga() {
  yield fork(reportEntity.watcher);
  yield takeLatest(types.EXPORT_REPORT, exportReportSaga);
}
